export const EXPERIMENTS = {
    USE_WARMUP_DATA_AND_LIST_FORMS_ECOM: 'spec.forms.UseWarmUpDataAndListFormsEcom',
    USE_WARMUP_DATA_AND_LIST_FORMS_PP_QUIZZES: 'spec.forms.UseWarmUpDataAndListFormsPPQuizzes',
};
//# sourceMappingURL=experiments.js.map